import PersonOutline from './PersonOutline';

export default PersonOutline;
